// extracted by mini-css-extract-plugin
export var calendarBtn = "personal-training-callendar-module--calendar-btn--E49Qp";
export var calendarHolder = "personal-training-callendar-module--calendar-holder--23yna";
export var dotHolderDay = "personal-training-callendar-module--dot-holder-day---vLA9";
export var dotHolderFooter = "personal-training-callendar-module--dot-holder-footer--uQH03";
export var inputCalendarStyle = "personal-training-callendar-module--input-calendar-style--etAlP";
export var reactCalendar = "personal-training-callendar-module--react-calendar--uXUDl";